module.exports = __webpack_public_path__ + "img/chinese-medicine-bottombg.1aea20e3.png";